/** Private property imagery must not survive an explicit sign-out. */
export const PROPERTY_TILE_CACHE = 'property-tiles-v2'

export async function clearPrivateCaches(storage: Pick<CacheStorage, 'delete'> = caches): Promise<void> {
  await storage.delete(PROPERTY_TILE_CACHE)
}
